export default {
  en: {
    "admin.label.client_id": "Client Id",
    "admin.label.currency_code": "Currency Code",
    "admin.label.autopay": "Autopay",
    "admin.label.Checker": "Checker",
    "admin.label.ConductorReport": "Conductor Report",
    "admin.label.ResourceId": "Resource Id",
    "admin.label.ReferenceId": "Reference Id",
    "admin.label.MakerDate": "Maker Date",
    "admin.label.CheckerDate": "Checker Date",
    "admin.label.ConfigureMakerChecker": "Configure Maker Checker",
    "admin.label.PaymentGatewayRemarks": "Payment Gateway Remarks",
    "admin.label.Approvals": "Approvals",
    "admin.label.MakerCheckerApprovals": "Maker Checker Approvals",
    "admin.label.ActionName": "Action Name",
    "admin.label.Code": "Code",
    "admin.label.ViewMessageLog": "View Message Log",
    "admin.label.MessageLog": "Message Log",
    "admin.label.MessageTo": "Message To",
    "admin.label.MessageFrom": "Message From",
    "admin.label.Subject": "Subject",
    "admin.label.MessageType": "Message Type",
    "admin.label.Template": "Template",
    "admin.label.EntityName": "Business Entity Name",
    "admin.label.Grouping": "Grouping",
    "admin.label.Selected": "Selected",
    "admin.label.Actions": "Actions",
    "admin.label.Maker": "Maker",
    "admin.label.Commands": "Commands",
    "admin.label.ViewApproval": "View Approval",
    "admin.label.CreatedOn": "Created On",
    "admin.label.Comment": "Comment",
    "admin.label.Approve": "Approve",
    "admin.label.Reject": "Reject",
    "admin.label.status": "Status",
    "admin.label.DateFormat": "Date Format",
    "admin.labelCommandDetails": "Command Details",
    "admin.label.Locale": "Locale",
    "admin.label.SystemDate": "System Date",
    "admin.label.EditPaymentGateway": "Edit Payment Gateway",
    "admin.label.Bulk Uploads": "Bulk Uploads",
    "admin.label.Upload File": "Upload File",
    "admin.label.Documents Uploads": "Documents Upload",
    "admin.label.Name": "Name",
    "admin.label.Due Date": "Due Date",
    "admin.label.Create Ticket": "Create Ticket",
    "admin.label.Provisioning System": "Provisioning System",
    "admin.label.URL": "URL",
    "admin.label.Password": "Password",
    "admin.label.Email Id": "Email Id",
    "admin.label.Promotional Message": "Promotional Message",
    "admin.label.User Name": "User Name",
    "admin.label.Description": "Description",
    "admin.label.Clear": "Clear",
    "admin.label.Scheduler Jobs": "Scheduler Jobs",
    "admin.label.Next Run": "Next Run",
    "admin.label.Previous Run": "Previous Run",
    "admin.label.Previous Run Status": "Previous Run Status",
    "admin.label.Active": "Active",
    "admin.label.Suspend": "Suspend",
    "admin.label.Execute": "Execute",
    "admin.label.Edit Scheduler Job": "Edit Scheduler Job",
    "admin.label.Job Name": "Job Name",
    "admin.label.Cron Expression": "Cron Expression",
    "admin.label.Cron Description": "Cron Description",
    "admin.label.Edit Jobs Parameters": "Edit Jobs Parameters",
    "admin.label.Process Date": "Process Date",
    "admin.label.Is Dynamic": "Is Dynamic",
    "admin.label.Scheduler Job History": "Scheduler Job History",
    "admin.label.Version": "Version",
    "admin.label.Run Start Time": "Run Start Time",
    "admin.label.Run Type": "Run Type",
    "admin.label.Log File": "Log File",
    "admin.label.Is Active Job?": "Is Active Job?",
    "admin.label.Follow": "Follow",
    "admin.label.Message Template": "Message Template",
    "admin.label.Online Payment": "Online Payments",
    "admin.label.Payment Id": "Payment Id",
    "admin.label.Payment Date": "Payment Date",
    "admin.label.Phone MSISDN": "Phone MSISDN",
    "admin.label.Serial No": "Serial No",
    "admin.label.Receipt No": "Receipt No",
    "admin.label.Amount Paid": "Amount Paid",
    "admin.label.Remarks": "Remarks",
    "admin.label.Ravepay reprocess": "Ravepay Reprocess",
    "admin.label.Select Payment Source": "Select Payment Source",
    "admin.label.Download Payment Gateway": "Download Payment Gateway",
    "admin.label.Download": "Download",
    "admin.label.From Date": "From Date",
    "admin.label.To Date": "To Date",
    "admin.label.Transaction Id": "Transaction Id",
    "admin.label.Reprocess": "Reprocess",
    "admin.label.Confirm": "Confirm",
    "admin.label.Search": "Search",
    "admin.label.Provisioning Orders": "Provisioning Orders",
    "admin.label.Client Id": "Client Id",
    "admin.label.Device": "Device",
    "admin.label.Request Type": "Request Type",
    "admin.label.Created Date": "Created Date",
    "admin.label.Response Message": "Response Message",
    "admin.label.Response Status": "Response Status",
    "admin.label.ReProcess Provisioning Order": "Reprocess Provisioning Order",
    "admin.label.Hooks Event Actions": "Hooks Event Actions",
    "admin.label.Transaction Date": "Transaction Date",
    "admin.label.Event Action": "Event Action",
    "admin.label.Command": "Command",
    "admin.label.Save": "Save",
    "admin.label.Cancel": "Cancel",
    "admin.label.Submit": "Submit",
    "admin.label.Id": "ID",
    "admin.label.Status": "Status",
    "admin.label.Action": "Action",
    "admin.label.Ok": "Ok",
    "admin.label.Activate": "Activate",
    "admin.label.Edit": "Edit",
    "admin.label.Job History": "Job History",
    "admin.label.Upload Process": "Upload Process",
    "admin.label.Upload File Path": "Upload File Path",
    "admin.label.Process/Total Records": "Process/Total Records",
    "admin.label.CheckerComment": "Checker Comment"
  },

  fr: {
    "admin.label.client_id": "ID du client",
    "admin.label.currency_code": "Code de devise",
    "admin.label.autopay": "Paiement automatique",
    "admin.label.Checker": "Vérificateur",
    "admin.label.ConductorReport": "Rapport du Conducteur",
    "admin.label.ResourceId": "Identifiant de ressource",
    "admin.label.ReferenceId": "Identifiant de référence",
    "admin.label.MakerDate": "Date de création",
    "admin.label.CheckerDate": "Date de vérification",
    "admin.label.ConfigureMakerChecker": "Configurer Maker Checker",
    "admin.label.Approvals": "Approbations",
    "admin.label.MakerCheckerApprovals":
      "Approbations du vérificateur de fabricant",
    "admin.label.ActionName": "Nom de l'action",
    "admin.label.Code": "Code",
    "admin.label.ViewMessageLog": "Voir le journal des messages",
    "admin.label.MessageLog": "Journal des messages",
    "admin.label.MessageTo": "Message à",
    "admin.label.MessageFrom": "Message de",
    "admin.label.Subject": "Sujet",
    "admin.label.MessageType": "Type de message",
    "admin.label.Template": "Modèle",
    "admin.label.EntityName": "Nom de l'entité",
    "admin.label.Grouping": "Regroupement",
    "admin.label.Selected": "Choisi",
    "admin.label.Actions": "Actes",
    "admin.label.Maker": "Fabricant",
    "admin.label.CreatedOn": "Créé le",
    "admin.label.Comment": "Commentaire",
    "admin.label.PaymentGatewayRemarks":
      "Remarque sur la passerelle de paiement",
    "admin.label.Approve": "Approuver",
    "admin.label.Reject": "Rejeter",
    "admin.label.EditPaymentGateway": "Modifier la passerelle de paiement",
    "admin.label.Bulk Uploads": "Téléchargements groupés",
    "admin.label.Upload File": "Télécharger le fichier",
    "admin.label.Documents Uploads": "Téléchargements de documents",
    "admin.label.Name": "Nom",
    "admin.label.Due Date": "Date d'échéance",
    "admin.label.Create Ticket": "Créer un ticket",
    "admin.label.Provisioning System": "Système de provisionnement",
    "admin.label.URL": "URL",
    "admin.label.Password": "Mot de passe",
    "admin.label.Email Id": "Adresse e-mail",
    "admin.label.Promotional Message": "Message promotionnel",
    "admin.label.User Name": "Nom d'utilisateur",
    "admin.label.Description": "Description",
    "admin.label.Clear": "Effacer",
    "admin.label.Scheduler Jobs": "Tâches du planificateur",
    "admin.label.Next Run": "Prochaine exécution",
    "admin.label.Previous Run": "Exécution précédente",
    "admin.label.Previous Run Status": "Statut de l'exécution précédente",
    "admin.label.Active": "Actif",
    "admin.label.Suspend": "Suspendre",
    "admin.label.Execute": "Exécuter",
    "admin.label.Edit Scheduler Job": "Modifier la tâche du planificateur",
    "admin.label.Job Name": "Nom de la tâche",
    "admin.label.Cron Expression": "Expression Cron",
    "admin.label.Cron Description": "Description Cron",
    "admin.label.Edit Jobs Parameters": "Modifier les paramètres de la tâche",
    "admin.label.Process Date": "Date de traitement",
    "admin.label.Is Dynamic": "Est dynamique",
    "admin.label.Scheduler Job History":
      "Historique des tâches du planificateur",
    "admin.label.Version": "Version",
    "admin.label.Run Start Time": "Heure de début de l'exécution",
    "admin.label.Run Type": "Type d'exécution",
    "admin.label.Log File": "Fichier journal",
    "admin.label.Is Active Job?": "Est-ce un travail actif ?",
    "admin.label.Follow": "Suivre",
    "admin.label.Message Template": "Modèle de message",
    "admin.label.Online Payment": "Paiement en ligne",
    "admin.label.Payment Id": "Identifiant de paiement",
    "admin.label.Payment Date": "Date de paiement",
    "admin.label.Phone MSISDN": "Téléphone MSISDN",
    "admin.label.Serial No": "Numéro de série",
    "admin.label.Receipt No": "Numéro de réception",
    "admin.label.Amount Paid": "Montant payé",
    "admin.label.Remarks": "Remarques",
    "admin.label.Ravepay reprocess": "Reprocessus Ravepay",
    "admin.label.Select Payment Source": "Sélectionner la source de paiement",
    "admin.label.Download Payment Gateway":
      "Télécharger la passerelle de paiement",
    "admin.label.Download": "Télécharger",
    "admin.label.From Date": "De la date",
    "admin.label.To Date": "À la date",
    "admin.label.Transaction Id": "Identifiant de transaction",
    "admin.label.Reprocess": "Reprocessus",
    "admin.label.Confirm": "Confirmer",
    "admin.label.Search": "Rechercher",
    "admin.label.Provisioning Orders": "Ordres de provisionnement",
    "admin.label.Client Id": "Identifiant client",
    "admin.label.Device": "Appareil",
    "admin.label.Request Type": "Type de demande",
    "admin.label.Created Date": "Date de création",
    "admin.label.Response Message": "Message de réponse",
    "admin.label.Response Status": "Statut de la réponse",
    "admin.label.ReProcess Provisioning Order":
      "Reprocessez l'ordre de provisionnement",
    "admin.label.Hooks Event Actions": "Actions d'événement des crochets",
    "admin.label.Transaction Date": "Date de transaction",
    "admin.label.Event Action": "Action d'événement",
    "admin.label.Command": "Commande",
    "admin.label.Save": "Enregistrer",
    "admin.label.Cancel": "Annuler",
    "admin.label.Submit": "Soumettre",
    "admin.label.Id": "Identifiant",
    "admin.label.Status": "Statut",
    "admin.label.Action": "Action",
    "admin.label.Ok": "Ok",
    "admin.label.Activate": "Activer",
    "admin.label.Edit": "Modifier",
    "admin.label.Job History": "Historique des tâches",
    "admin.label.Upload Process": "Processus de téléchargement",
    "admin.label.Upload File Path": "Chemin du fichier à télécharger",
    "admin.label.Process/Total Records": "Processus/Total des enregistrements",
    "admin.label.status": "Statut",
    "admin.label.DateFormat": "Format de date",
    "admin.labelCommandDetails": "Détails de la commande",
    "admin.label.Locale": "Langue",
    "admin.label.SystemDate": "Date du système",
    "admin.label.CheckerComment": "Commentaire du vérificateur",
  },

  es: {
    "admin.label.client_id": "ID de cliente",
    "admin.label.currency_code": "Código de moneda",
    "admin.label.autopay": "Pago automático",
    "admin.label.Checker": "Verificador",
    "admin.label.ConductorReport": "Informe del Conductor",
    "admin.label.ResourceId": "ID de recurso",
    "admin.label.ReferenceId": "ID de referencia",
    "admin.label.MakerDate": "Fecha de creación",
    "admin.label.CheckerDate": "Fecha de verificación",
    "admin.label.ConfigureMakerChecker": "Configurar Maker Checker",
    "admin.label.Approvals": "Aprobaciones",
    "admin.label.MakerCheckerApprovals": "Aprobaciones de Maker Checker",
    "admin.label.ActionName": "Nombre de la acción",
    "admin.label.Code": "Código",
    "admin.label.ViewMessageLog": "Ver el registro de mensajes",
    "admin.label.MessageLog": "Registro de mensajes",
    "admin.label.MessageTo": "Mensaje para",
    "admin.label.MessageFrom": "Mensaje de",
    "admin.label.Subject": "Asunto",
    "admin.label.MessageType": "Tipo de mensaje",
    "admin.label.Template": "Plantilla",
    "admin.label.EntityName": "Nombre de la entidad",
    "admin.label.Grouping": "Agrupamiento",
    "admin.label.Selected": "Seleccionado",
    "admin.label.Actions": "Comportamiento",
    "admin.label.Maker": "Fabricante",
    "admin.label.CreatedOn": "Creado el",
    "admin.label.Comment": "Comentario",
    "admin.label.PaymentGatewayRemarks": "Comentarios de la pasarela de pago",
    "admin.label.Approve": "Aprobar",
    "admin.label.Reject": "Rechazar",
    "admin.label.status": "Estado",
    "admin.label.DateFormat": "Formato de fecha",
    "admin.labelCommandDetails": "Detalles del comando",
    "admin.label.Locale": "Idioma",
    "admin.label.SystemDate": "Fecha del sistema",
    "admin.label.EditPaymentGateway": "Editar pasarela de pago",
    "admin.label.Bulk Uploads": "Cargas masivas",
    "admin.label.Upload File": "Subir archivo",
    "admin.label.Documents Uploads": "Cargas de documentos",
    "admin.label.Name": "Nombre",
    "admin.label.Due Date": "Fecha de vencimiento",
    "admin.label.Create Ticket": "Crear ticket",
    "admin.label.Provisioning System": "Sistema de aprovisionamiento",
    "admin.label.URL": "URL",
    "admin.label.Password": "Contraseña",
    "admin.label.Email Id": "Correo electrónico",
    "admin.label.Promotional Message": "Mensaje promocional",
    "admin.label.User Name": "Nombre de usuario",
    "admin.label.Description": "Descripción",
    "admin.label.Clear": "Limpiar",
    "admin.label.Scheduler Jobs": "Trabajos del programador",
    "admin.label.Next Run": "Siguiente ejecución",
    "admin.label.Previous Run": "Ejecución anterior",
    "admin.label.Previous Run Status": "Estado de la ejecución anterior",
    "admin.label.Active": "Activo",
    "admin.label.Suspend": "Suspender",
    "admin.label.Execute": "Ejecutar",
    "admin.label.Edit Scheduler Job": "Editar trabajo del programador",
    "admin.label.Job Name": "Nombre del trabajo",
    "admin.label.Cron Expression": "Expresión Cron",
    "admin.label.Cron Description": "Descripción Cron",
    "admin.label.Edit Jobs Parameters": "Editar parámetros del trabajo",
    "admin.label.Process Date": "Fecha de proceso",
    "admin.label.Is Dynamic": "Es Dinámico",
    "admin.label.Scheduler Job History":
      "Historial de trabajos del programador",
    "admin.label.Version": "Versión",
    "admin.label.Run Start Time": "Hora de inicio de la ejecución",
    "admin.label.Run Type": "Tipo de ejecución",
    "admin.label.Log File": "Archivo de registro",
    "admin.label.Is Active Job?": "¿Es un trabajo activo?",
    "admin.label.Follow": "Seguir",
    "admin.label.Message Template": "Plantilla de mensaje",
    "admin.label.Online Payment": "Pago en línea",
    "admin.label.Payment Id": "Identificación de pago",
    "admin.label.Payment Date": "Fecha de pago",
    "admin.label.Phone MSISDN": "Teléfono MSISDN",
    "admin.label.Serial No": "Número de serie",
    "admin.label.Receipt No": "Número de recibo",
    "admin.label.Amount Paid": "Cantidad pagada",
    "admin.label.Remarks": "Observaciones",
    "admin.label.Ravepay reprocess": "Reprocesar Ravepay",
    "admin.label.Select Payment Source": "Seleccionar fuente de pago",
    "admin.label.Download Payment Gateway": "Descargar pasarela de pago",
    "admin.label.Download": "Descargar",
    "admin.label.From Date": "Desde la fecha",
    "admin.label.To Date": "Hasta la fecha",
    "admin.label.Transaction Id": "Identificación de transacción",
    "admin.label.Reprocess": "Reprocesar",
    "admin.label.Confirm": "Confirmar",
    "admin.label.Search": "Buscar",
    "admin.label.Provisioning Orders": "Órdenes de aprovisionamiento",
    "admin.label.Client Id": "ID de cliente",
    "admin.label.Device": "Dispositivo",
    "admin.label.Request Type": "Tipo de solicitud",
    "admin.label.Created Date": "Fecha de creación",
    "admin.label.Response Message": "Mensaje de respuesta",
    "admin.label.Response Status": "Estado de la respuesta",
    "admin.label.ReProcess Provisioning Order":
      "Reprocesar orden de aprovisionamiento",
    "admin.label.Hooks Event Actions": "Acciones de eventos de ganchos",
    "admin.label.Transaction Date": "Fecha de transacción",
    "admin.label.Event Action": "Acción de evento",
    "admin.label.Command": "Comando",
    "admin.label.Save": "Guardar",
    "admin.label.Cancel": "Cancelar",
    "admin.label.Submit": "Enviar",
    "admin.label.Id": "ID",
    "admin.label.Status": "Estado",
    "admin.label.Action": "Accione",
    "admin.label.Ok": "Ok",
    "admin.label.Activate": "Activar",
    "admin.label.Edit": "Editar",
    "admin.label.Job History": "Historial de trabajos",
    "admin.label.Upload Process": "Proceso de carga",
    "admin.label.Upload File Path": "Ruta del archivo a cargar",
    "admin.label.Process/Total Records": "Proceso/Total de registros",
    "admin.label.CheckerComment": "Comentario del verificador",
  },

  pt: {
    "admin.label.client_id": "ID do cliente",
    "admin.label.currency_code": "Código da moeda",
    "admin.label.autopay": "Pagamento automático",
    "admin.label.Checker": "Verificador",
    "admin.label.ConductorReport": "Relatório do Condutor",
    "admin.label.ResourceId": "ID do recurso",
    "admin.label.ReferenceId": "ID de referência",
    "admin.label.MakerDate": "Data de criação",
    "admin.label.CheckerDate": "Data do verificador",
    "admin.label.ConfigureMakerChecker": "Configurar o Verificador do Maker",
    "admin.label.Approvals": "Aprovações",
    "admin.label.MakerCheckerApprovals": "Aprovações do Maker Checker",
    "admin.label.ActionName": "Nome da ação",
    "admin.label.Code": "Código",
    "admin.label.ViewMessageLog": "Ver o registro de mensagens",
    "admin.label.MessageLog": "Registro de mensagens",
    "admin.label.MessageTo": "Mensagem para",
    "admin.label.MessageFrom": "Mensagem de",
    "admin.label.Subject": "Assunto",
    "admin.label.MessageType": "Tipo de mensagem",
    "admin.label.Template": "Modelo",
    "admin.label.EntityName": "Nome da Entidade",
    "admin.label.Grouping": "Agrupamento",
    "admin.label.Selected": "Selecionado",
    "admin.label.Actions": "Ações",
    "admin.label.Maker": "Criador",
    "admin.label.CreatedOn": "Criado em",
    "admin.label.Comment": "Comentário",
    "admin.label.PaymentGatewayRemarks": "Observações do gateway de pagamento",
    "admin.label.Approve": "Aprovar",
    "admin.label.Reject": "Rejeitar",
    "admin.label.status": "Status",
    "admin.label.DateFormat": "Formato de data",
    "admin.labelCommandDetails": "Detalhes do comando",
    "admin.label.Locale": "Localidade",
    "admin.label.SystemDate": "Data do sistema",
    "admin.label.EditPaymentGateway": "Editar gateway de pagamento",
    "admin.label.Bulk Uploads": "Envios em massa",
    "admin.label.Upload File": "Enviar arquivo",
    "admin.label.Documents Uploads": "Envios de documentos",
    "admin.label.Name": "Nome",
    "admin.label.Due Date": "Data de vencimento",
    "admin.label.Create Ticket": "Criar ticket",
    "admin.label.Provisioning System": "Sistema de provisionamento",
    "admin.label.URL": "URL",
    "admin.label.Password": "Senha",
    "admin.label.Email Id": "Endereço de e-mail",
    "admin.label.Promotional Message": "Mensagem promocional",
    "admin.label.User Name": "Nome de usuário",
    "admin.label.Description": "Descrição",
    "admin.label.Clear": "Limpar",
    "admin.label.Scheduler Jobs": "Trabalhos do agendador",
    "admin.label.Next Run": "Próxima execução",
    "admin.label.Previous Run": "Execução anterior",
    "admin.label.Previous Run Status": "Estado da execução anterior",
    "admin.label.Active": "Ativo",
    "admin.label.Suspend": "Suspender",
    "admin.label.Execute": "Executar",
    "admin.label.Edit Scheduler Job": "Editar trabalho do agendador",
    "admin.label.Job Name": "Nome do trabalho",
    "admin.label.Cron Expression": "Expressão Cron",
    "admin.label.Cron Description": "Descrição Cron",
    "admin.label.Edit Jobs Parameters": "Editar parâmetros do trabalho",
    "admin.label.Process Date": "Data de Processamento",
    "admin.label.Is Dynamic": "É Dinâmico",
    "admin.label.Scheduler Job History": "Histórico de trabalhos do agendador",
    "admin.label.Version": "Versão",
    "admin.label.Run Start Time": "Hora de início da execução",
    "admin.label.Run Type": "Tipo de execução",
    "admin.label.Log File": "Arquivo de log",
    "admin.label.Is Active Job?": "É um trabalho ativo?",
    "admin.label.Follow": "Seguir",
    "admin.label.Message Template": "Modelo de mensagem",
    "admin.label.Online Payment": "Pagamento online",
    "admin.label.Payment Id": "Identificação do pagamento",
    "admin.label.Payment Date": "Data do pagamento",
    "admin.label.Phone MSISDN": "Telefone MSISDN",
    "admin.label.Serial No": "Número de série",
    "admin.label.Receipt No": "Número do recibo",
    "admin.label.Amount Paid": "Valor pago",
    "admin.label.Remarks": "Observações",
    "admin.label.Ravepay reprocess": "Reprocessar Ravepay",
    "admin.label.Select Payment Source": "Selecionar fonte de pagamento",
    "admin.label.Download Payment Gateway": "Baixar gateway de pagamento",
    "admin.label.Download": "Baixar",
    "admin.label.From Date": "Da data",
    "admin.label.To Date": "Até a data",
    "admin.label.Transaction Id": "Identificação da transação",
    "admin.label.Reprocess": "Reprocessar",
    "admin.label.Confirm": "Confirmar",
    "admin.label.Search": "Pesquisar",
    "admin.label.Provisioning Orders": "Ordens de provisionamento",
    "admin.label.Client Id": "ID do cliente",
    "admin.label.Device": "Dispositivo",
    "admin.label.Request Type": "Tipo de solicitação",
    "admin.label.Created Date": "Data de criação",
    "admin.label.Response Message": "Mensagem de resposta",
    "admin.label.Response Status": "Status da resposta",
    "admin.label.ReProcess Provisioning Order":
      "Reprocessar ordem de provisionamento",
    "admin.label.Hooks Event Actions": "Ações de Eventos de Ganchos",
    "admin.label.Transaction Date": "Data da Transação",
    "admin.label.Event Action": "Ação do Evento",
    "admin.label.Command": "Comando",
    "admin.label.Save": "Salvar",
    "admin.label.Cancel": "Cancelar",
    "admin.label.Submit": "Enviar",
    "admin.label.Id": "ID",
    "admin.label.Status": "Estado",
    "admin.label.Action": "Açõe",
    "admin.label.Ok": "Ok",
    "admin.label.Activate": "Ativar",
    "admin.label.Edit": "Editar",
    "admin.label.Job History": "Histórico de trabalhos",
    "admin.label.Upload Process": "Processo de upload",
    "admin.label.Upload File Path": "Caminho do arquivo para upload",
    "admin.label.Process/Total Records": "Processo/Total de registros",
    "admin.label.CheckerComment": "Comentário do verificador",
  },

  zh_CN: {
    "admin.label.client_id": "客户 ID",
    "admin.label.currency_code": "货币代码",
    "admin.label.autopay": "自动支付",
    "admin.label.Checker": "检查员",
    "admin.label.ConductorReport": "司机报告",
    "admin.label.ResourceId": "资源ID",
    "admin.label.ReferenceId": "参考编号",
    "admin.label.MakerDate": "制造商日期",
    "admin.label.CheckerDate": "检查员日期",
    "admin.label.ConfigureMakerChecker": "配置製造商檢查器",
    "admin.label.Approvals": "核准",
    "admin.label.MakerCheckerApprovals": "製造商檢查器批准",
    "admin.label.ActionName": "動作名稱",
    "admin.label.Code": "程式碼",
    "admin.label.ViewMessageLog": "查看消息日志",
    "admin.label.MessageLog": "消息日志",
    "admin.label.MessageTo": "接收方",
    "admin.label.MessageFrom": "发送方",
    "admin.label.Subject": "主题",
    "admin.label.MessageType": "消息类型",
    "admin.label.Template": "模板",
    "admin.label.EntityName": "實體名稱",
    "admin.label.Grouping": "分組",
    "admin.label.Selected": "已選擇",
    "admin.label.Actions": "行動",
    "admin.label.Maker": "創客",
    "admin.label.CreatedOn": "創建於",
    "admin.label.Comment": "評論",
    "admin.label.PaymentGatewayRemarks": "支付网关备注",
    "admin.label.Approve": "核准",
    "admin.label.Reject": "拒絕",
    "admin.label.status": "状态",
    "admin.label.DateFormat": "日期格式",
    "admin.labelCommandDetails": "命令详情",
    "admin.label.Locale": "语言环境",
    "admin.label.SystemDate": "系统日期",
    "admin.label.EditPaymentGateway": "编辑支付网关",
    "admin.label.Bulk Uploads": "批量上传",
    "admin.label.Upload File": "上传文件",
    "admin.label.Documents Uploads": "文件上传",
    "admin.label.Name": "名称",
    "admin.label.Due Date": "到期日期",
    "admin.label.Create Ticket": "创建工单",
    "admin.label.Provisioning System": "供应系统",
    "admin.label.URL": "网址",
    "admin.label.Password": "密码",
    "admin.label.Email Id": "电子邮件地址",
    "admin.label.Promotional Message": "促销信息",
    "admin.label.User Name": "用户名",
    "admin.label.Description": "描述",
    "admin.label.Clear": "清除",
    "admin.label.Scheduler Jobs": "调度程序作业",
    "admin.label.Next Run": "下次运行",
    "admin.label.Previous Run": "上次运行",
    "admin.label.Previous Run Status": "上次运行状态",
    "admin.label.Active": "激活",
    "admin.label.Suspend": "暂停",
    "admin.label.Execute": "执行",
    "admin.label.Edit Scheduler Job": "编辑调度程序作业",
    "admin.label.Job Name": "作业名称",
    "admin.label.Cron Expression": "Cron表达式",
    "admin.label.Cron Description": "Cron描述",
    "admin.label.Edit Jobs Parameters": "编辑作业参数",
    "admin.label.Process Date": "处理日期",
    "admin.label.Is Dynamic": "是否动态",
    "admin.label.Scheduler Job History": "调度程序作业历史记录",
    "admin.label.Version": "版本",
    "admin.label.Run Start Time": "运行开始时间",
    "admin.label.Run Type": "运行类型",
    "admin.label.Log File": "日志文件",
    "admin.label.Is Active Job?": "是否活动作业？",
    "admin.label.Follow": "跟进",
    "admin.label.Message Template": "消息模板",
    "admin.label.Online Payment": "在线支付",
    "admin.label.Payment Id": "付款ID",
    "admin.label.Payment Date": "付款日期",
    "admin.label.Phone MSISDN": "电话MSISDN",
    "admin.label.Serial No": "序列号",
    "admin.label.Receipt No": "收据编号",
    "admin.label.Amount Paid": "付款金额",
    "admin.label.Remarks": "备注",
    "admin.label.Ravepay reprocess": "Ravepay 重新处理",
    "admin.label.Select Payment Source": "选择付款来源",
    "admin.label.Download Payment Gateway": "下载支付网关",
    "admin.label.Download": "下载",
    "admin.label.From Date": "开始日期",
    "admin.label.To Date": "结束日期",
    "admin.label.Transaction Id": "交易ID",
    "admin.label.Reprocess": "重新处理",
    "admin.label.Confirm": "确认",
    "admin.label.Search": "搜索",
    "admin.label.Provisioning Orders": "配置订单",
    "admin.label.Client Id": "客户端 ID",
    "admin.label.Device": "设备",
    "admin.label.Request Type": "请求类型",
    "admin.label.Created Date": "创建日期",
    "admin.label.Response Message": "响应消息",
    "admin.label.Response Status": "响应状态",
    "admin.label.ReProcess Provisioning Order": "重新处理配置订单",
    "admin.label.Hooks Event Actions": "钩子事件操作",
    "admin.label.Transaction Date": "交易日期",
    "admin.label.Event Action": "事件操作",
    "admin.label.Command": "命令",
    "admin.label.Save": "保存",
    "admin.label.Cancel": "取消",
    "admin.label.Submit": "提交",
    "admin.label.Id": "ID",
    "admin.label.Status": "状态",
    "admin.label.Action": "操作",
    "admin.label.Ok": "确定",
    "admin.label.Activate": "激活",
    "admin.label.Edit": "编辑",
    "admin.label.Job History": "作业历史",
    "admin.label.Upload Process": "上传流程",
    "admin.label.Upload File Path": "上传文件路径",
    "admin.label.Process/Total Records": "处理/总记录数",
    "admin.label.CheckerComment": "检查员评论",
  },

  hi: {
    "admin.label.client_id": "ग्राहक आईडी",
    "admin.label.currency_code": "मुद्रा कोड",
    "admin.label.autopay": "स्वत: भुगतान",
    "admin.label.Checker": "चेकर",
    "admin.label.ConductorReport": "चालक रिपोर्ट",
    "admin.label.ResourceId": "संसाधन आईडी",
    "admin.label.ReferenceId": "संदर्भ आईडी",
    "admin.label.MakerDate": "निर्माता दिनांक",
    "admin.label.CheckerDate": "चेक दिनांक",
    "admin.label.ConfigureMakerChecker": "मेकर चेकर कॉन्फ़िगर करें",
    "admin.label.Approvals": "स्वीकृति",
    "admin.label.MakerCheckerApprovals": "मेकर चेकर अनुमोदन",
    "admin.label.ActionName": "क्रिया का नाम",
    "admin.label.Code": "कोड",
    "admin.label.ViewMessageLog": "संदेश लॉग देखें",
    "admin.label.MessageLog": "संदेश लॉग",
    "admin.label.MessageTo": "संदेश प्राप्तकर्ता",
    "admin.label.MessageFrom": "संदेश प्रेषक",
    "admin.label.Subject": "विषय",
    "admin.label.MessageType": "संदेश प्रकार",
    "admin.label.Template": "टेम्पलेट",
    "admin.label.EntityName": "इकाई का नाम",
    "admin.label.Grouping": "समूहन",
    "admin.label.Selected": "चयनित",
    "admin.label.Actions": "कार्रवाई",
    "admin.label.Maker": "निर्माता",
    "admin.label.CreatedOn": "पर बनाया",
    "admin.label.Comment": "टिप्पणी",
    "admin.label.PaymentGatewayRemarks": "भुगतान गेटवे टिप्पणियाँ",
    "admin.label.Approve": "मंज़ूरी देना",
    "admin.label.Reject": "अस्वीकार करना",
    "admin.label.status": "स्थिति",
    "admin.label.DateFormat": "तिथि प्रारूप",
    "admin.labelCommandDetails": "आदेश विवरण",
    "admin.label.Locale": "स्थानीय",
    "admin.label.SystemDate": "सिस्टम तिथि",
    "admin.label.EditPaymentGateway": "भुगतान गेटवे संपादित करें",
    "admin.label.Bulk Uploads": "थोक अपलोड",
    "admin.label.Upload File": "फ़ाइल अपलोड करें",
    "admin.label.Documents Uploads": "दस्तावेज़ अपलोड",
    "admin.label.Name": "नाम",
    "admin.label.Due Date": "नियत तारीख",
    "admin.label.Create Ticket": "टिकट बनाएं",
    "admin.label.Provisioning System": "प्रोविजनिंग सिस्टम",
    "admin.label.URL": "यूआरएल",
    "admin.label.Password": "पासवर्ड",
    "admin.label.Email Id": "ईमेल पता",
    "admin.label.Promotional Message": "प्रचार संदेश",
    "admin.label.User Name": "उपयोगकर्ता नाम",
    "admin.label.Description": "विवरण",
    "admin.label.Clear": "साफ़",
    "admin.label.Scheduler Jobs": "शेड्यूलर जॉब्स",
    "admin.label.Next Run": "अगली रन",
    "admin.label.Previous Run": "पिछली रन",
    "admin.label.Previous Run Status": "पिछली रन स्थिति",
    "admin.label.Active": "सक्रिय",
    "admin.label.Suspend": "स्थगित",
    "admin.label.Execute": "क्रियान्वित",
    "admin.label.Edit Scheduler Job": "शेड्यूलर जॉब संपादित करें",
    "admin.label.Job Name": "कार्य नाम",
    "admin.label.Cron Expression": "क्रोन अभिव्यक्ति",
    "admin.label.Cron Description": "क्रोन विवरण",
    "admin.label.Edit Jobs Parameters": "कार्य पैरामीटर संपादित करें",
    "admin.label.Process Date": "प्रोसेस डेट",
    "admin.label.Is Dynamic": "डायनामिक है",
    "admin.label.Scheduler Job History": "शेड्यूलर जॉब इतिहास",
    "admin.label.Version": "संस्करण",
    "admin.label.Run Start Time": "चलन शुरू समय",
    "admin.label.Run Type": "चलन प्रकार",
    "admin.label.Log File": "लॉग फ़ाइल",
    "admin.label.Is Active Job?": "क्या यह सक्रिय नौकरी है?",
    "admin.label.Follow": "पालन",
    "admin.label.Message Template": "संदेश टेम्पलेट",
    "admin.label.Online Payment": "ऑनलाइन भुगतान",
    "admin.label.Payment Id": "भुगतान आईडी",
    "admin.label.Payment Date": "भुगतान तिथि",
    "admin.label.Phone MSISDN": "फोन MSISDN",
    "admin.label.Serial No": "क्रम संख्या",
    "admin.label.Receipt No": "रसीद संख्या",
    "admin.label.Amount Paid": "भुगतान राशि",
    "admin.label.Remarks": "टिप्पणियाँ",
    "admin.label.Ravepay reprocess": "रेवपेप फिर से प्रक्रिया करें",
    "admin.label.Select Payment Source": "भुगतान स्रोत चुनें",
    "admin.label.Download Payment Gateway": "भुगतान गेटवे डाउनलोड करें",
    "admin.label.Download": "डाउनलोड",
    "admin.label.From Date": "तारीख से",
    "admin.label.To Date": "तारीख तक",
    "admin.label.Transaction Id": "लेन-देन आईडी",
    "admin.label.Reprocess": "पुनः प्रक्रिया",
    "admin.label.Confirm": "पुष्टि करें",
    "admin.label.Search": "खोज",
    "admin.label.Provisioning Orders": "प्रोविजनिंग आदेश",
    "admin.label.Client Id": "ग्राहक आईडी",
    "admin.label.Device": "उपकरण",
    "admin.label.Request Type": "अनुरोध प्रकार",
    "admin.label.Created Date": "निर्मित तिथि",
    "admin.label.Response Message": "प्रतिक्रिया संदेश",
    "admin.label.Response Status": "प्रतिक्रिया स्थिति",
    "admin.label.ReProcess Provisioning Order":
      "प्रोविजनिंग आदेश फिर से प्रक्रिया करें",
    "admin.label.Hooks Event Actions": "हुक्स घटना क्रियाएँ",
    "admin.label.Transaction Date": "लेन-देन की तारीख",
    "admin.label.Event Action": "घटना क्रिया",
    "admin.label.Command": "कमांड",
    "admin.label.Save": "सहेजें",
    "admin.label.Cancel": "रद्द करें",
    "admin.label.Submit": "प्रस्तुत करें",
    "admin.label.Id": "आईडी",
    "admin.label.Status": "स्थिति",
    "admin.label.Action": "क्रियाएँ",
    "admin.label.Ok": "ठीक है",
    "admin.label.Activate": "सक्रिय करें",
    "admin.label.Edit": "संपादित करें",
    "admin.label.Job History": "नौकरी का इतिहास",
    "admin.label.Upload Process": "अपलोड प्रक्रिया",
    "admin.label.Upload File Path": "फ़ाइल पथ अपलोड करें",
    "admin.label.Process/Total Records": "प्रक्रिया/कुल रिकॉर्ड",
    "admin.label.CheckerComment": "चेकर टिप्पणी",
  },

  ka: {
    "admin.label.client_id": "კლიენტის ID",
    "admin.label.currency_code": "ვალუტის კოდი",
    "admin.label.autopay": "ავტო გადახდა",
    "admin.label.Checker": "შემომავალი",
    "admin.label.ConductorReport": "მძღოლის ანგარიში",
    "admin.label.ResourceId": "რესურსის ID",
    "admin.label.ReferenceId": "საეტაპო ID",
    "admin.label.MakerDate": "შექმნილია",
    "admin.label.CheckerDate": "შემომავალის თარიღი",
    "admin.label.ConfigureMakerChecker": "Maker Checker-ის კონფიგურაცია",
    "admin.label.Approvals": "დამტკიცებები",
    "admin.label.MakerCheckerApprovals": "Maker Checker დამტკიცებები",
    "admin.label.ActionName": "მოქმედების სახელი",
    "admin.label.Code": "კოდი",
    "admin.label.ViewMessageLog": "შეტყობინებების ჟურნალის ნახვა",
    "admin.label.MessageLog": "მესიჯების ჟურნალი",
    "admin.label.MessageTo": "მესიჯის მიმღები",
    "admin.label.MessageFrom": "მესიჯის გამომგზავნი",
    "admin.label.Subject": "თემა",
    "admin.label.MessageType": "მესიჯის ტიპი",
    "admin.label.Template": "შაბლონი",
    "admin.label.EntityName": "ერთეულის სახელი",
    "admin.label.Grouping": "დაჯგუფება",
    "admin.label.Selected": "შერჩეული",
    "admin.label.Actions": "მოქმედებები",
    "admin.label.Maker": "შემქმნელი",
    "admin.label.CreatedOn": "შექმნილია",
    "admin.label.Comment": "კომენტარი",
    "admin.label.PaymentGatewayRemarks": "ಪಾವತಿ ಗೇಟ್ವೇ ಟಿಪ್ಪಣಿಗಳು",
    "admin.label.Approve": "დამტკიცება",
    "admin.label.Reject": "უარყოფა",
    "admin.label.status": "ಸ್ಥಿತಿ",
    "admin.label.DateFormat": "ದಿನಾಂಕ ಸ್ವರೂಪ",
    "admin.labelCommandDetails": "ಆಜ್ಞೆ ವಿವರಗಳು",
    "admin.label.Locale": "ಸ್ಥಳೀಯ",
    "admin.label.SystemDate": "ಸಿಸ್ಟಮ್ ದಿನಾಂಕ",
    "admin.label.EditPaymentGateway": "ಪಾವತಿ ಗೇಟ್ವೇ ಸಂಪಾದಿಸಿ",
    "admin.label.Bulk Uploads": "მრიცხველი ატვირთვები",
    "admin.label.Upload File": "ფაილის ატვირთვა",
    "admin.label.Documents Uploads": "დოკუმენტების ატვირთვები",
    "admin.label.Name": "სახელი",
    "admin.label.Due Date": "ვადის ბოლო თარიღი",
    "admin.label.Create Ticket": "ბილეთის შექმნა",
    "admin.label.Provisioning System": "გადანაწილების სისტემა",
    "admin.label.URL": "URL",
    "admin.label.Password": "პაროლი",
    "admin.label.Email Id": "ელფოსტის მისამართი",
    "admin.label.Promotional Message": "სარეკლამო შეტყობინება",
    "admin.label.User Name": "მომხმარებლის სახელი",
    "admin.label.Description": "აღწერა",
    "admin.label.Clear": "გასუფთავება",
    "admin.label.Scheduler Jobs": "განზომილების დავალებები",
    "admin.label.Next Run": "შემდეგი გაშვება",
    "admin.label.Previous Run": "წინა გაშვება",
    "admin.label.Previous Run Status": "წინა გაშვების სტატუსი",
    "admin.label.Active": "აქტიური",
    "admin.label.Suspend": "შეჩერება",
    "admin.label.Execute": "შესრულება",
    "admin.label.Edit Scheduler Job": "განზომილების დავალების რედაქტირება",
    "admin.label.Job Name": "დავალების სახელი",
    "admin.label.Cron Expression": "Cron გამოსახულება",
    "admin.label.Cron Description": "Cron აღწერა",
    "admin.label.Edit Jobs Parameters": "დავალების პარამეტრების რედაქტირება",
    "admin.label.Process Date": "პროცესის თარიღი",
    "admin.label.Is Dynamic": "დინამიურია",
    "admin.label.Scheduler Job History": "განზომილების დავალების ისტორია",
    "admin.label.Version": "ვერსია",
    "admin.label.Run Start Time": "გაშვების დაწყების დრო",
    "admin.label.Run Type": "გაშვების ტიპი",
    "admin.label.Log File": "ლოგ ფაილი",
    "admin.label.Is Active Job?": "აქტიური სამუშაოა?",
    "admin.label.Follow": "გამომყველება",
    "admin.label.Message Template": "შეტყობინება შაბლონი",
    "admin.label.Online Payment": "ონლაინ გადახდა",
    "admin.label.Payment Id": "გადახდის ID",
    "admin.label.Payment Date": "გადახდის თარიღი",
    "admin.label.Phone MSISDN": "ტელეფონის MSISDN",
    "admin.label.Serial No": "სერიული ნომერი",
    "admin.label.Receipt No": "მიღების ნომერი",
    "admin.label.Amount Paid": "გადახდილი თანხა",
    "admin.label.Remarks": "შენიშვნები",
    "admin.label.Ravepay reprocess": "Ravepay-ის ხელახლა დამუშავება",
    "admin.label.Select Payment Source": "გადახდის წყვილის არჩევა",
    "admin.label.Download Payment Gateway":
      "გადახდის შესვლის გზაში ჩამოტვირთვა",
    "admin.label.Download": "ჩამოტვირთვა",
    "admin.label.From Date": "თარიღიდან",
    "admin.label.To Date": "თარიღამდე",
    "admin.label.Transaction Id": "ტრანზაქციის ID",
    "admin.label.Reprocess": "ხელახლა დამუშავება",
    "admin.label.Confirm": "დადასტურება",
    "admin.label.Search": "ძებნა",
    "admin.label.Provisioning Orders": "პროვიზიონირების ბრძანებები",
    "admin.label.Client Id": "კლიენტის ID",
    "admin.label.Device": "მოწყობილობა",
    "admin.label.Request Type": "მოთხოვნის ტიპი",
    "admin.label.Created Date": "შექმნის თარიღი",
    "admin.label.Response Message": "პასუხის შეტყობინება",
    "admin.label.Response Status": "პასუხის სტატუსი",
    "admin.label.ReProcess Provisioning Order":
      "პროვიზიონირების ბრძანების ხელახალი დამუშავება",
    "admin.label.Hooks Event Actions": "ჰუკების მოვლენები",
    "admin.label.Transaction Date": "Გადახდის თარიღი",
    "admin.label.Event Action": "მოვლენა",
    "admin.label.Command": "ბრძანება",
    "admin.label.Save": "შენახვა",
    "admin.label.Cancel": "გაუქმება",
    "admin.label.Submit": "წარმოადგენეთ",
    "admin.label.Id": "ID",
    "admin.label.Status": "სტატუსი",
    "admin.label.Action": "ქმედებები",
    "admin.label.Ok": "კარგი",
    "admin.label.Activate": "გააქტიურება",
    "admin.label.Edit": "რედაქტირება",
    "admin.label.Job History": "სამუშაო ისტორია",
    "admin.label.Upload Process": "ატვირთვის პროცესი",
    "admin.label.Upload File Path": "ფაილის ატვირთვის გზა",
    "admin.label.Process/Total Records": "პროცესი/ჯამური ჩანაწერები",
    "admin.label.CheckerComment": "შემომავალის კომენტარი",
  },

  lo: {
    "admin.label.client_id": "ID ລູກຄ້າ",
    "admin.label.currency_code": "ລະຫັດສະກຸນເງິນ",
    "admin.label.autopay": "ການຈ່າຍເງິນອັດຕະໂນມັດ",
    "admin.label.Checker": "ກວດສອບ",
    "admin.label.ConductorReport": "รายงานคนขับ",
    "admin.label.ResourceId": "ລະບົບ ID",
    "admin.label.ReferenceId": "ລະຫັດອ້າງອິງ",
    "admin.label.MakerDate": "ສ້າງເມື່ອ",
    "admin.label.CheckerDate": "ກວດສອບວັນທີ",
    "admin.label.ConfigureMakerChecker": "ຕັ້ງຄ່າຕົວກວດສອບຜູ້ສ້າງ",
    "admin.label.Approvals": "ການອະນຸມັດ",
    "admin.label.MakerCheckerApprovals": "ການອະນຸມັດຕົວກວດສອບຜູ້ສ້າງ",
    "admin.label.ActionName": "ຊື່ການປະຕິບັດ",
    "admin.label.Code": "ລະຫັດ",
    "admin.label.ViewMessageLog": "ເບິ່ງບັນທຶກຂໍ້ຄວາມ",
    "admin.label.MessageLog": "ບັນທຶກຂໍ້ຄວາມ",
    "admin.label.MessageTo": "ຂໍ້ຄວາມຫາ",
    "admin.label.MessageFrom": "ຂໍ້ຄວາມຈາກ",
    "admin.label.Subject": "ຫົວຂໍ້",
    "admin.label.MessageType": "ປະເພດຂໍ້ຄວາມ",
    "admin.label.Template": "ແບບແຜນ",
    "admin.label.EntityName": "ຊື່ນິຕິບຸກຄົນ",
    "admin.label.Grouping": "ການຈັດກຸ່ມ",
    "admin.label.Selected": "ເລືອກແລ້ວ",
    "admin.label.Actions": "ການປະຕິບັດ",
    "admin.label.Maker": "ຜູ້ຜະລິດ",
    "admin.label.CreatedOn": "ສ້າງເມື່ອ",
    "admin.label.Comment": "ຄໍາເຫັນ",
    "admin.label.PaymentGatewayRemarks": "ໝາຍເຫດຂອງປະຕູຈ່າຍເງິນ",
    "admin.label.Approve": "ອະນຸມັດ",
    "admin.label.Reject": "ປະຕິເສດ",
    "admin.label.status": "ສະຖານະ",
    "admin.label.DateFormat": "ຮູບແບບວັນທີ",
    "admin.labelCommandDetails": "ລາຍລະອຽດຄຳສັ່ງ",
    "admin.label.Locale": "ພາສາ",
    "admin.label.SystemDate": "ວັນທີຂອງລະບົບ",
    "admin.label.EditPaymentGateway": "ແກ້ໄຂປະຕູຈ່າຍເງິນ",
    "admin.label.Bulk Uploads": "ອອກອອກອອກສໍາລັບ",
    "admin.label.Upload File": "ອັບໂຫລດໄຟລາຍການ",
    "admin.label.Documents Uploads": "ອອກເອກະສານອອກອອກອອກ",
    "admin.label.Name": "ຊື່",
    "admin.label.Due Date": "ວັນທີຄົບກຳນົດ",
    "admin.label.Create Ticket": "ສ້າງບັດ",
    "admin.label.Provisioning System": "ລະບົບການຈັດຫາ",
    "admin.label.URL": "URL",
    "admin.label.Password": "ລະຫັດຜ່ານ",
    "admin.label.Email Id": "ອີເມວ",
    "admin.label.Promotional Message": "ຂໍ້ຄວາມໂຄສະນາ",
    "admin.label.User Name": "ຊື່ຜູ້ໃຊ້",
    "admin.label.Description": "ລາຍລະອຽດ",
    "admin.label.Clear": "ລ້າງ",
    "admin.label.Scheduler Jobs": "ເຮັດວຽກວິດະີໂອ",
    "admin.label.Next Run": "ການເຂົ້າເຖິງການປະມານເລີ່ມຕົ້ນ",
    "admin.label.Previous Run": "ການເຂົ້າກັບກ່ອນ",
    "admin.label.Previous Run Status": "ສະຖານະການເຂົ້າກັບກ່ອນ",
    "admin.label.Active": "ເປີດໃຊ້",
    "admin.label.Suspend": "ປິດ",
    "admin.label.Execute": "ປະຕິບັດ",
    "admin.label.Edit Scheduler Job": "ແກ້ໄຂວຽກວິດະີໂອ",
    "admin.label.Job Name": "ຊື່ວຽກ",
    "admin.label.Cron Expression": "ຕົວແປ Cron",
    "admin.label.Cron Description": "ລາຍລະອຽດ Cron",
    "admin.label.Edit Jobs Parameters": "ແກ້ໄຂພາລັງວຽກ",
    "admin.label.Process Date": "ວັນທີການປະມານ",
    "admin.label.Is Dynamic": "ແມ່ນດີກວ່າການເຮັດວຽກ",
    "admin.label.Scheduler Job History": "ປະຫວັດການເຮັດວຽກວິດະີໂອ",
    "admin.label.Version": "ລຸ່ມນີ້",
    "admin.label.Run Start Time": "ເລີ່ມເວລາການເຮັດວຽກ",
    "admin.label.Run Type": "ປະເພດການເຮັດວຽກ",
    "admin.label.Log File": "ແຜນຂະຫນາດບັນທືກ",
    "admin.label.Is Active Job?": "ວຽກນີ້ເຮັດວຽກ?",
    "admin.label.Follow": "ຕິດຕາມ",
    "admin.label.Message Template": "ເຢັດໂຕະຂໍ້ຄວາມ",
    "admin.label.Online Payment": "ການຊຳລະຂໍ້ມູນອອກໄດ້",
    "admin.label.Payment Id": "ລະຫັດການຈ່າຍ",
    "admin.label.Payment Date": "ວັນທີ່ຈ່າຍ",
    "admin.label.Phone MSISDN": "ເບີໂທ MSISDN",
    "admin.label.Serial No": "ຫມາຍເລກລໍ້ທີ່",
    "admin.label.Receipt No": "ເລກໃບຮັບລາຍຈ່າຍ",
    "admin.label.Amount Paid": "ຈ່າຍຄ່າ",
    "admin.label.Remarks": "ຄຳເຫັນ",
    "admin.label.Ravepay reprocess": "ສະຫຼັບ Ravepay",
    "admin.label.Select Payment Source": "ເລືອກຕົ້ນທາງການຈ່າຍ",
    "admin.label.Download Payment Gateway": "ດາວໂຫຼດວິດີໂອດັດຄວາມ",
    "admin.label.Download": "ດາວໂຫຼດ",
    "admin.label.From Date": "ຈາກວັນທີ",
    "admin.label.To Date": "ຫາວັນທີ",
    "admin.label.Transaction Id": "ລະຫັດການຈ່າຍ",
    "admin.label.Reprocess": "ສະຫຼັບຄືນ",
    "admin.label.Confirm": "ຢືນຢັນ",
    "admin.label.Search": "ຄົ້ນຫາ",
    "admin.label.Provisioning Orders": "ການສະເໜີໃນການສັ່ງສອນ",
    "admin.label.Client Id": "ID ລູກຄ້າ",
    "admin.label.Device": "ອຸປະກອນ",
    "admin.label.Request Type": "ປະເພດຂໍ້ມູນຂໍ້ມູນ",
    "admin.label.Created Date": "ວັນທີ່ສ້າງແລ້ວ",
    "admin.label.Response Message": "ຂໍ້ຄວາມຕອບຮັບ",
    "admin.label.Response Status": "ສະຖານະຄວາມຕອບຮັບ",
    "admin.label.ReProcess Provisioning Order": "ດຳເນີນການສັ່ງສອນຄືນ",
    "admin.label.Hooks Event Actions": "ການປະຕິບັດການຍົກຍົກກຳນົດ",
    "admin.label.Transaction Date": "ວັນທີ່ເຮັດລາຍະການ",
    "admin.label.Event Action": "ການຍົກຍົກກຳນົດການ",
    "admin.label.Command": "ຄໍາຮ້ອງ",
    "admin.label.Save": "ບັນທຶກ",
    "admin.label.Cancel": "ຍົກເລີກ",
    "admin.label.Submit": "ໂຕະ",
    "admin.label.Id": "ລະຫັດ",
    "admin.label.Status": "ສະຖານະ",
    "admin.label.Action": "ການດຳເນີນການ",
    "admin.label.Ok": "ຖືກ",
    "admin.label.Activate": "ເປີດໃຊ້ງານ",
    "admin.label.Edit": "ແກ້ໄຂ",
    "admin.label.Job History": "ປະຫວັດການຊ່ວຍເຫຼືອ",
    "admin.label.Upload Process": "ຊຳລະການອັບໂຫຼດ",
    "admin.label.Upload File Path": "ເສັ້ນທາງໄຟລ໌ອັບໂຫຼດ",
    "admin.label.Process/Total Records": "ຊຳລະ/ຈຳນວນທັງໝົດຂໍ້ມູນ",
    "admin.label.CheckerComment": "ຄໍາເຫັນການກວດສອບ",
  },

  my_MM: {
    "admin.label.client_id": "ဖောက်သည် ID",
    "admin.label.currency_code": "ငွေကြေးကုဒ်",
    "admin.label.autopay": "အလိုအလျောက်ငွေပေးချေမှု",
    "admin.label.Checker": "စစ်စစ်သူ",
    "admin.label.ConductorReport": "ယာဉ်မောင်းအစီရင်ခံစာ",
    "admin.label.ResourceId": "စနစ် ID",
    "admin.label.ReferenceId": "အညွှန်းအိုင်ဒီ",
    "admin.label.MakerDate": "ဖန်တီးသူရက်",
    "admin.label.CheckerDate": "စစ်စစ်သူရက်",
    "admin.label.ConfigureMakerChecker": "Maker Checker ကို စီစဉ်သတ်မှတ်ပါ။",
    "admin.label.Approvals": "အတည်ပြုချက်များ",
    "admin.label.MakerCheckerApprovals": "ဖန်တီးသူ စစ်ဆေးသူ အတည်ပြုချက်များ",
    "admin.label.ActionName": "လုပ်ဆောင်ချက်အမည်",
    "admin.label.Code": "ကုတ်",
    "admin.label.ViewMessageLog": "မက်ဆေ့ခ်ျမှတ်တမ်းကိုကြည့်ရန်",
    "admin.label.MessageLog": "မက်ဆေ့ချ် မှတ်တမ်း",
    "admin.label.MessageTo": "မက်ဆေ့ချ် ပို့ရန်",
    "admin.label.MessageFrom": "မက်ဆေ့ချ် ပေးပို့သူ",
    "admin.label.Subject": "ခေါင်းစဉ်",
    "admin.label.MessageType": "မက်ဆေ့ချ်အမျိုးအစား",
    "admin.label.Template": "ပုံစံတူစာမျက်နှာ",
    "admin.label.EntityName": "အဖွဲ့အစည်းအမည်",
    "admin.label.Grouping": "အုပ်စုဖွဲ့ခြင်း။",
    "admin.label.Selected": "ရွေးချယ်ခဲ့သည်။",
    "admin.label.Actions": "လုပ်ဆောင်ချက်များ",
    "admin.label.Maker": "ထုတ်လုပ်သူ",
    "admin.label.CreatedOn": "တွင်ဖန်တီးခဲ့သည်။",
    "admin.label.Comment": "မှတ်ချက်",
    "admin.label.PaymentGatewayRemarks": "ငွေပေးချေမှု ဂိတ်မှတ်ချက်များ",
    "admin.label.Approve": "လက်မခံပါ။",
    "admin.label.Reject": "ငြင်းပယ်ပါ။",
    "admin.label.status": "အခြေအနေ",
    "admin.label.DateFormat": "ရက်စွဲပုံစံ",
    "admin.labelCommandDetails": "အမိန့်အသေးစိတ်",
    "admin.label.Locale": "ဒေသပြည်",
    "admin.label.SystemDate": "စနစ်ရက်စွဲ",
    "admin.label.EditPaymentGateway": "ငွေပေးချေမှုဂိတ်ကို တည်းဖြတ်ပါ",
    "admin.label.Bulk Uploads": "အသစ်တင်ရန်",
    "admin.label.Upload File": "ဖိုင်တင်ရန်",
    "admin.label.Documents Uploads": "စာရင်းတင်ရန်",
    "admin.label.Name": "နာမည်",
    "admin.label.Due Date": "နောက်ဆုံးထားရမည့်နေ့",
    "admin.label.Create Ticket": "လက်မှတ်ပြုလုပ်မည်",
    "admin.label.Provisioning System": "တပ်ဆင်ရေးစနစ်",
    "admin.label.URL": "URL",
    "admin.label.Password": "စကားဝှက်",
    "admin.label.Email Id": "အီးမေးလ်လိပ်စာ",
    "admin.label.Promotional Message": "ကြော်ငြာစာ",
    "admin.label.User Name": "အသုံးပြုသူအမည်",
    "admin.label.Description": "ဖော်ပြချက်",
    "admin.label.Clear": "ရှင်းလင်းရန်",
    "admin.label.Scheduler Jobs": "အကြောင်းအရာများ",
    "admin.label.Next Run": "နောက်ဆုံးဆွဲချက်",
    "admin.label.Previous Run": "ယခင်ဆွဲချက်",
    "admin.label.Previous Run Status": "ယခင်အဆုံးအစား",
    "admin.label.Active": "ဖွင့်လှစ်",
    "admin.label.Suspend": "ရပ်တည်သော",
    "admin.label.Execute": "ပြုလုပ်ပါ",
    "admin.label.Edit Scheduler Job": "ကြော်ငြာအကြောင်းအရာပြုပြင်ရန်",
    "admin.label.Job Name": "အလုပ်အကိုင်",
    "admin.label.Cron Expression": "ခရိုင်းပြန်စာ",
    "admin.label.Cron Description": "ခရိုင်းဖော်ပြချက်",
    "admin.label.Edit Jobs Parameters": "အလုပ်အကိုင်ပုံစံများပြုပြင်ရန်",
    "admin.label.Process Date": "လုပ်ဆောင်သည့်နေ့စွဲ",
    "admin.label.Is Dynamic": "ရိုးရှင်းလိုသည့်ဖြစ်ပါသည်",
    "admin.label.Scheduler Job History":
      "အကြောင်းအရာများနှင့်ဇယ်တင်းတင်မှုသမိုင်း",
    "admin.label.Version": "ဗားရှင်း",
    "admin.label.Run Start Time": "ကြည့်ရန်စတင်ခဲ့သည့်အချိန်",
    "admin.label.Run Type": "ကြည့်ရန်အမျိုးအစား",
    "admin.label.Log File": "မှတ်တမ်းဖိုင်",
    "admin.label.Is Active Job?": "အလုပ်ကိုအလုပ်ရေးပြီးပြီးလား",
    "admin.label.Follow": "ပရိုဂရမ်",
    "admin.label.Message Template": "စာတိုက်စစ်စုံအဖြစ်",
    "admin.label.Online Payment": "ငွေပေးချေမှု အော်ဒါအသစ်",
    "admin.label.Payment Id": "ငွေပေးချေမှု အော်ဒါအမှတ်",
    "admin.label.Payment Date": "ငွေပေးချေမှုရက်စွဲ",
    "admin.label.Phone MSISDN": "ဖုန်း MSISDN",
    "admin.label.Serial No": "စျေးနှုန်း နံပါတ်",
    "admin.label.Receipt No": "လက်ကျန်ငွေငွေနံပါတ်",
    "admin.label.Amount Paid": "ငွေပေးချေမှု ပေးချေငွေ",
    "admin.label.Remarks": "မှတ်ချက်",
    "admin.label.Ravepay reprocess": "Ravepay ထပ်မံပြုလုပ်ပါ",
    "admin.label.Select Payment Source":
      "ငွေပေးချေမှု ရွေးချယ်ရန် ရွေးချယ်ခြင်း",
    "admin.label.Download Payment Gateway":
      "ငွေပေးချေမှု လမ်းညွှန်တင်သွင်းရန် ဒေါင်းလုတ်",
    "admin.label.Download": "ဒေါင်းလုတ်",
    "admin.label.From Date": "ရက်စွဲမှ",
    "admin.label.To Date": "ရက်စွဲအထိ",
    "admin.label.Transaction Id": "ငွေပေးချေမှု အော်ဒါအမှတ်",
    "admin.label.Reprocess": "ပြုပြင်ခြင်း",
    "admin.label.Confirm": "အတည်ပြုပါ",
    "admin.label.Search": "ရှာဖွေပါ",
    "admin.label.Provisioning Orders": "ပေးစွမ်းသုံးခြင်းများ",
    "admin.label.Client Id": "ဖိုလ်ဒါ ID",
    "admin.label.Device": "ကိရိယာ",
    "admin.label.Request Type": "တောင်းဆိုခွင့်",
    "admin.label.Created Date": "ဖန်တီးသည့်ရက်စွဲ",
    "admin.label.Response Message": "ပြန်လည်တင်သွင်းနိုင်သည့်စာသား",
    "admin.label.Response Status": "ပြန်လည်တင်သွင်းနိုင်သည့်အခြေအနေ",
    "admin.label.ReProcess Provisioning Order":
      "ပေးစွမ်းသုံးခြင်းနှင့်ပြန်လည်စစ်ပါ",
    "admin.label.Hooks Event Actions": "Hooks Event Actions",
    "admin.label.Transaction Date": "ငွေသွင်းခဲ့သည့်နေ့စွဲ",
    "admin.label.Event Action": "Event Action",
    "admin.label.Command": "Command",
    "admin.label.Save": "သိမ်းဆည်း",
    "admin.label.Cancel": "ပယ်ဖျက်မည်",
    "admin.label.Submit": "တင်သွင်းမည်",
    "admin.label.Id": "အခြေအနေ",
    "admin.label.Status": "အဆင့်မြှင့်",
    "admin.label.Action": "လုပ်ရန်",
    "admin.label.Ok": "အိုး",
    "admin.label.Activate": "ဖွင့်ရန်",
    "admin.label.Edit": "တည်းဖြတ်ပါ",
    "admin.label.Job History": "အလုပ်သမားများ၏နှစ်သက်သေပမှု",
    "admin.label.Upload Process": "တင်ရန်လုပ်ဆောင်ခြင်း",
    "admin.label.Upload File Path": "ဖိုင်အလိုအေလ်ာက်ဖြည့်ရန်လမ်းညွှန်",
    "admin.label.Process/Total Records": "လုပ်ဆောင်ခြင်း/စုစုပေါင်းစာရင်းများ",
    "admin.label.CheckerComment": "စစ်စစ်သူမှတ်ချက်",
  },

  my: {
    "admin.label.client_id": "ဖောက်သည် ID",
    "admin.label.currency_code": "ငွေကြေးကုဒ်",
    "admin.label.autopay": "အလိုအလျောက်ငွေပေးချေမှု",
    "admin.label.Checker": "စစ်စစ်သူ",
    "admin.label.ConductorReport": "ယာဉ်မောင်းအစီရင်ခံစာ",
    "admin.label.ResourceId": "စနစ် ID",
    "admin.label.ReferenceId": "အညွှန်းအိုင်ဒီ",
    "admin.label.MakerDate": "ဖန်တီးသူရက်",
    "admin.label.CheckerDate": "စစ်စစ်သူရက်",
    "admin.label.ConfigureMakerChecker": "Maker Checker ကို စီစဉ်သတ်မှတ်ပါ။",
    "admin.label.Approvals": "အတည်ပြုချက်များ",
    "admin.label.MakerCheckerApprovals": "ဖန်တီးသူ စစ်ဆေးသူ အတည်ပြုချက်များ",
    "admin.label.ActionName": "လုပ်ဆောင်ချက်အမည်",
    "admin.label.Code": "ကုတ်",
    "admin.label.ViewMessageLog": "မက်ဆေ့ခ်ျမှတ်တမ်းကိုကြည့်ရန်",
    "admin.label.MessageLog": "မက်ဆေ့ချ် မှတ်တမ်း",
    "admin.label.MessageTo": "မက်ဆေ့ချ် ပို့ရန်",
    "admin.label.MessageFrom": "မက်ဆေ့ချ် ပေးပို့သူ",
    "admin.label.Subject": "ခေါင်းစဉ်",
    "admin.label.MessageType": "မက်ဆေ့ချ်အမျိုးအစား",
    "admin.label.Template": "ပုံစံတူစာမျက်နှာ",
    "admin.label.EntityName": "အဖွဲ့အစည်းအမည်",
    "admin.label.Grouping": "အုပ်စုဖွဲ့ခြင်း။",
    "admin.label.Selected": "ရွေးချယ်ခဲ့သည်။",
    "admin.label.Actions": "လုပ်ဆောင်ချက်များ",
    "admin.label.Maker": "ထုတ်လုပ်သူ",
    "admin.label.CreatedOn": "တွင်ဖန်တီးခဲ့သည်။",
    "admin.label.Comment": "မှတ်ချက်",
    "admin.label.PaymentGatewayRemarks": "ငွေပေးချေမှု ဂိတ်မှတ်ချက်များ",
    "admin.label.Approve": "လက်မခံပါ။",
    "admin.label.Reject": "ငြင်းပယ်ပါ။",
    "admin.label.status": "အခြေအနေ",
    "admin.label.DateFormat": "ရက်စွဲပုံစံ",
    "admin.labelCommandDetails": "အမိန့်အသေးစိတ်",
    "admin.label.Locale": "ဒေသပြည်",
    "admin.label.SystemDate": "စနစ်ရက်စွဲ",
    "admin.label.EditPaymentGateway": "ငွေပေးချေမှုဂိတ်ကို တည်းဖြတ်ပါ",
    "admin.label.Bulk Uploads": "အသစ်တင်ရန်",
    "admin.label.Upload File": "ဖိုင်တင်ရန်",
    "admin.label.Documents Uploads": "စာရင်းတင်ရန်",
    "admin.label.Name": "နာမည်",
    "admin.label.Due Date": "နောက်ဆုံးထားရမည့်နေ့",
    "admin.label.Create Ticket": "လက်မှတ်ဖန်တီးမည်",
    "admin.label.Provisioning System": "ပံ့ပိုးမှုစနစ်",
    "admin.label.URL": "URL",
    "admin.label.Password": "စကားဝှက်",
    "admin.label.Email Id": "အီးမေးလ်လိပ်စာ",
    "admin.label.Promotional Message": "ကြော်ငြာစာ",
    "admin.label.User Name": "အသုံးပြုသူအမည်",
    "admin.label.Description": "ဖော်ပြချက်",
    "admin.label.Clear": "ရှင်းလင်းရန်",
    "admin.label.Scheduler Jobs": "အကြောင်းအရာများ",
    "admin.label.Next Run": "နောက်ဆုံးဆွဲချက်",
    "admin.label.Previous Run": "ယခင်ဆွဲချက်",
    "admin.label.Previous Run Status": "ယခင်အဆုံးအစား",
    "admin.label.Active": "ဖွင့်လှစ်",
    "admin.label.Suspend": "ရပ်တည်သော",
    "admin.label.Execute": "ပြုလုပ်ပါ",
    "admin.label.Edit Scheduler Job": "ကြော်ငြာအကြောင်းအရာပြုပြင်ရန်",
    "admin.label.Job Name": "အလုပ်အကိုင်",
    "admin.label.Cron Expression": "ခရိုင်းပြန်စာ",
    "admin.label.Cron Description": "ခရိုင်းဖော်ပြချက်",
    "admin.label.Edit Jobs Parameters": "အလုပ်အကိုင်ပုံစံများပြုပြင်ရန်",
    "admin.label.Process Date": "လုပ်ဆောင်သည့်နေ့စွဲ",
    "admin.label.Is Dynamic": "ရိုးရှင်းလိုသည့်ဖြစ်ပါသည်",
    "admin.label.Scheduler Job History":
      "အကြောင်းအရာများနှင့်ဇယ်တင်းတင်မှုသမိုင်း",
    "admin.label.Version": "ဗားရှင်း",
    "admin.label.Run Start Time": "ကြည့်ရန်စတင်ခဲ့သည့်အချိန်",
    "admin.label.Run Type": "ကြည့်ရန်အမျိုးအစား",
    "admin.label.Log File": "မှတ်တမ်းဖိုင်",
    "admin.label.Is Active Job?": "အလုပ်ကိုအလုပ်ရေးပြီးပြီးလား",
    "admin.label.Follow": "ပရိုဂရမ်",
    "admin.label.Message Template": "စာတိုက်စစ်စုံအဖြစ်",
    "admin.label.Online Payment": "အွန်လိုင်းငွေပေးချေမှု",
    "admin.label.Payment Id": "ငွေပေးချေမှု အော်ဒါအမှတ်",
    "admin.label.Payment Date": "ငွေပေးချေမှုရက်စွဲ",
    "admin.label.Phone MSISDN": "ဖုန်း MSISDN",
    "admin.label.Serial No": "စျေးနှုန်း နံပါတ်",
    "admin.label.Receipt No": "လက်ကျန်ငွေငွေနံပါတ်",
    "admin.label.Amount Paid": "ငွေပေးချေမှု ပေးချေငွေ",
    "admin.label.Remarks": "မှတ်ချက်",
    "admin.label.Ravepay reprocess": "Ravepay ထပ်မံပြုလုပ်ပါ",
    "admin.label.Select Payment Source":
      "ငွေပေးချေမှု ရွေးချယ်ရန် ရွေးချယ်ခြင်း",
    "admin.label.Download Payment Gateway":
      "ငွေပေးချေမှု လမ်းညွှန်တင်သွင်းရန် ဒေါင်းလုတ်",
    "admin.label.Download": "ဒေါင်းလုတ်",
    "admin.label.From Date": "ရက်စွဲမှ",
    "admin.label.To Date": "ရက်စွဲအထိ",
    "admin.label.Transaction Id": "ငွေပေးချေမှု အော်ဒါအမှတ်",
    "admin.label.Reprocess": "ပြုပြင်ခြင်း",
    "admin.label.Confirm": "အတည်ပြုပါ",
    "admin.label.Search": "ရှာဖွေပါ",
    "admin.label.Provisioning Orders": "ပေးစွမ်းခြင်းများ",
    "admin.label.Client Id": "ဖိုလ်ဒါ ID",
    "admin.label.Device": "ကိရိယာ",
    "admin.label.Request Type": "တောင်းဆိုခွင့်",
    "admin.label.Created Date": "ဖန်တီးသည့်ရက်စွဲ",
    "admin.label.Response Message": "ပြန်လည်တင်သွင်းနိုင်သည့်စာသား",
    "admin.label.Response Status": "ပြန်လည်တင်သွင်းနိုင်သည့်အခြေအနေ",
    "admin.label.ReProcess Provisioning Order":
      "ပေးစွမ်းသုံးခြင်းနှင့်ပြန်လည်စစ်ပါ",
    "admin.label.Hooks Event Actions": "ခေတ္တခါမှ ဖြစ်စဉ်စာရင်းများ",
    "admin.label.Transaction Date": "ငွေသွင်းခဲ့သည့်နေ့စွဲ",
    "admin.label.Event Action": "ဖြစ်စဉ် လုပ်ငန်း",
    "admin.label.Command": "Command",
    "admin.label.Save": "သိမ်းဆည်း",
    "admin.label.Cancel": "ပယ်ဖျက်မည်",
    "admin.label.Submit": "တင်သွင်းမည်",
    "admin.label.Id": "အခြေအနေ",
    "admin.label.Status": "အဆင့်မြှင့်",
    "admin.label.Action": "လုပ်ရန်",
    "admin.label.Ok": "အိုး",
    "admin.label.Activate": "ဖွင့်ရန်",
    "admin.label.Edit": "တည်းဖြတ်ပါ",
    "admin.label.Job History": "အလုပ်သမားများ၏နှစ်သက်သေပမှု",
    "admin.label.Upload Process": "တင်ရန်လုပ်ဆောင်ခြင်း",
    "admin.label.Upload File Path": "ဖိုင်အလိုအေလ်ာက်ဖြည့်ရန်လမ်းညွှန်",
    "admin.label.Process/Total Records": "လုပ်ဆောင်ခြင်း/စုစုပေါင်းစာရင်းများ",
    "admin.label.CheckerComment": "စစ်စစ်သူမှတ်ချက်",
  },

  vi: {
    "admin.label.client_id": "Mã khách hàng",
    "admin.label.currency_code": "Mã tiền tệ",
    "admin.label.autopay": "Thanh toán tự động",
    "admin.label.Checker": "Kiểm tra",
    "admin.label.ConductorReport": "Báo cáo tài xế",
    "admin.label.ResourceId": "ID Tài nguyên",
    "admin.label.ReferenceId": "Mã tham chiếu",
    "admin.label.MakerDate": "Ngày tạo",
    "admin.label.CheckerDate": "Ngày kiểm tra",
    "admin.label.ConfigureMakerChecker": "Định cấu hình Trình kiểm tra Maker",
    "admin.label.Approvals": "Phê duyệt",
    "admin.label.MakerCheckerApprovals": "Phê duyệt của Trình kiểm tra Maker",
    "admin.label.ActionName": "Tên hành động",
    "admin.label.Code": "Mã số",
    "admin.label.ViewMessageLog": "Xem nhật ký tin nhắn",
    "admin.label.MessageLog": "Nhật ký tin nhắn",
    "admin.label.MessageTo": "Tin nhắn đến",
    "admin.label.MessageFrom": "Tin nhắn từ",
    "admin.label.Subject": "Chủ đề",
    "admin.label.MessageType": "Loại tin nhắn",
    "admin.label.Template": "Mẫu",
    "admin.label.EntityName": "Tên thực thể",
    "admin.label.Grouping": "Nhóm",
    "admin.label.Selected": "Đã chọn",
    "admin.label.Actions": "hành động",
    "admin.label.Maker": "Người tạo",
    "admin.label.CreatedOn": "Được tạo vào",
    "admin.label.Comment": "Bình luận",
    "admin.label.PaymentGatewayRemarks": "Ghi chú Cổng thanh toán",
    "admin.label.Approve": "Chấp thuận",
    "admin.label.Reject": "Từ chối",
    "admin.label.status": "Trạng thái",
    "admin.label.DateFormat": "Định dạng ngày",
    "admin.labelCommandDetails": "Chi tiết lệnh",
    "admin.label.Locale": "Ngôn ngữ",
    "admin.label.SystemDate": "Ngày hệ thống",
    "admin.label.EditPaymentGateway": "Chỉnh sửa Cổng thanh toán",
    "admin.label.Bulk Uploads": "Tải lên hàng loạt",
    "admin.label.Upload File": "Tải lên tệp",
    "admin.label.Documents Uploads": "Tải lên tài liệu",
    "admin.label.Name": "Tên",
    "admin.label.Due Date": "Ngày đáo hạn",
    "admin.label.Create Ticket": "Tạo vé",
    "admin.label.Provisioning System": "Hệ thống cấp phát",
    "admin.label.URL": "URL",
    "admin.label.Password": "Mật khẩu",
    "admin.label.Email Id": "Địa chỉ email",
    "admin.label.Promotional Message": "Tin nhắn quảng cáo",
    "admin.label.User Name": "Tên người dùng",
    "admin.label.Description": "Mô tả",
    "admin.label.Clear": "Xóa",
    "admin.label.Scheduler Jobs": "Công việc lập lịch",
    "admin.label.Next Run": "Chạy tiếp theo",
    "admin.label.Previous Run": "Chạy trước đó",
    "admin.label.Previous Run Status": "Trạng thái chạy trước đó",
    "admin.label.Active": "Hoạt động",
    "admin.label.Suspend": "Tạm dừng",
    "admin.label.Execute": "Thực thi",
    "admin.label.Edit Scheduler Job": "Chỉnh sửa công việc lập lịch",
    "admin.label.Job Name": "Tên công việc",
    "admin.label.Cron Expression": "Biểu thức Cron",
    "admin.label.Cron Description": "Mô tả Cron",
    "admin.label.Edit Jobs Parameters": "Chỉnh sửa tham số công việc",
    "admin.label.Process Date": "Ngày xử lý",
    "admin.label.Is Dynamic": "Có Động",
    "admin.label.Scheduler Job History": "Lịch sử công việc lập lịch",
    "admin.label.Version": "Phiên bản",
    "admin.label.Run Start Time": "Thời gian bắt đầu chạy",
    "admin.label.Run Type": "Loại chạy",
    "admin.label.Log File": "Tập tin nhật ký",
    "admin.label.Is Active Job?": "Công việc có hoạt động không?",
    "admin.label.Follow": "Theo dõi",
    "admin.label.Message Template": "Mẫu tin nhắn",
    "admin.label.Online Payment": "Thanh toán trực tuyến",
    "admin.label.Payment Id": "ID Thanh toán",
    "admin.label.Payment Date": "Ngày thanh toán",
    "admin.label.Phone MSISDN": "Số điện thoại MSISDN",
    "admin.label.Serial No": "Số serial",
    "admin.label.Receipt No": "Số biên nhận",
    "admin.label.Amount Paid": "Số tiền đã thanh toán",
    "admin.label.Remarks": "Ghi chú",
    "admin.label.Ravepay reprocess": "Xử lý lại Ravepay",
    "admin.label.Select Payment Source": "Chọn nguồn thanh toán",
    "admin.label.Download Payment Gateway": "Tải về cổng thanh toán",
    "admin.label.Download": "Tải về",
    "admin.label.From Date": "Từ ngày",
    "admin.label.To Date": "Đến ngày",
    "admin.label.Transaction Id": "ID Giao dịch",
    "admin.label.Reprocess": "Xử lý lại",
    "admin.label.Confirm": "Xác nhận",
    "admin.label.Search": "Tìm kiếm",
    "admin.label.Provisioning Orders": "Đơn đặt hàng cung cấp",
    "admin.label.Client Id": "ID khách hàng",
    "admin.label.Device": "Thiết bị",
    "admin.label.Request Type": "Loại yêu cầu",
    "admin.label.Created Date": "Ngày tạo",
    "admin.label.Response Message": "Thông báo phản hồi",
    "admin.label.Response Status": "Trạng thái phản hồi",
    "admin.label.ReProcess Provisioning Order":
      "Xử lý lại đơn đặt hàng cung cấp",
    "admin.label.Hooks Event Actions": "Các hành động Sự kiện của Hooks",
    "admin.label.Transaction Date": "Ngày Giao dịch",
    "admin.label.Event Action": "Hành động Sự kiện",
    "admin.label.Command": "Lệnh",
    "admin.label.Save": "Lưu",
    "admin.label.Cancel": "Hủy bỏ",
    "admin.label.Submit": "Gửi",
    "admin.label.Id": "ID",
    "admin.label.Status": "Trạng thái",
    "admin.label.Action": "Hành động",
    "admin.label.Ok": "Ok",
    "admin.label.Activate": "Kích hoạt",
    "admin.label.Edit": "Chỉnh sửa",
    "admin.label.Job History": "Lịch sử công việc",
    "admin.label.Upload Process": "Quy trình tải lên",
    "admin.label.Upload File Path": "Đường dẫn tải lên tập tin",
    "admin.label.Process/Total Records": "Quy trình/Tổng số bản ghi",
    "admin.label.CheckerComment": "Bình luận của người kiểm tra",
  },
};
